var Colors = {
    black: '#000',
    white: '#fff',
    faded_gray: '(#2cb2a5 / 50%)',
    faded_icon : 'rgba(1,4,3,0.4)',

}
export default Colors